<div *ngIf="showErrors" class="errors">
  <div class="error" *ngIf="errors?.min">{{ 'app.ui-messages.error-min-value' | translate : { value: errors.min.min } }}</div>
  <div class="error" *ngIf="errors?.max">{{ 'app.ui-messages.error-max-value' | translate : { value: errors.max.max } }}</div>
  <div class="error" *ngIf="errors?.required">{{ 'app.ui-messages.error-required' | translate }}</div>
  <div class="error" *ngIf="errors?.pattern">
    <div *ngIf="showLetterAndNumberError">{{ 'app.ui-messages.error-letter-number' | translate }}</div>
  </div>
</div>
